import React, { useContext } from "react";
import { Link } from "react-router-dom";
import classes from "./Navbar.module.scss";
import axios from "axios";
import SessionInfo from "./SessionInfo";
import { menuContent } from "./menuContent";
import { OrgIdContext, ClientTypes } from "../../store/orgId_context";
import { ThemeContext } from "../../store/ThemeContext";
import { useTranslation } from 'react-i18next';
import { MenuContext } from "../../store/menu_context";
import {BaseContext} from "../../store/basepath";

const apiRequestAddress =
  process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

const DropdownMenu = ({ companyName, userName, mobileVersion, onItemClicked }) => {
  const { isIntegrator, ISVCustomer, AccCustomer, getRoles, sessionInfo } = useContext(OrgIdContext);
  const { theme } = useContext(ThemeContext);
  const {basepath} = useContext(BaseContext);
  const isIOT = sessionInfo?.User?.Id && sessionInfo?.Extended?.DeviceData?.Id && sessionInfo?.User?.Id === sessionInfo?.Extended?.DeviceData?.Id;

  const { t } = useTranslation();
  const forceTranslation = () =>{
    t("Company profile");
    t("Add team member");
    t("Change payment plan");
    t("Customer relations");
    t("Packages");
    t("Billing");
    t("Payments & billing");
    t("Team members");
    t("My profile");
  }

  const roles = getRoles();
  const onLogoutHandler = () => {
    axios
      .post(
        apiRequestAddress,
        { jsonrpc: "2.0", method: "Auth.SignOut", params: {}, id: 7 },
        {
          withCredentials: true,
        }
      )
      .then(() => {
        window.location = theme === 'GVC' ? 'https://www.globalvatcompliance.com/' : '@';
        sessionStorage.removeItem("mainOrgId");
      });
  };
  
  return (
    <div className={`${classes.dropdown} p-3`}>
      {mobileVersion && (
        <SessionInfo
          person={userName}
          company={companyName}
          className="text-center mb-3"
        />
      )}
      <ul>
        {menuContent.map((item, index) => {
          let contains = roles.some(i => item.roles.includes(i)) || item.roles.includes("all");
          if(!contains)
            return;
          if(isIOT && item.url === "/user-settings") return;
          return (
            <Link to={item.url} onClick={onItemClicked}>
              <li key={`dropdown-item-${index}`} className={classes.item}>
                {t(item.itemName)}
                <hr />
              </li>
            </Link>
          );
        })}
        {basepath !== "mycompany" && <>
        <li className={classes.logout} onClick={onLogoutHandler}>
          {t("Logout")}
        </li>
        </>}
      </ul>
    </div>
  );
};

export default DropdownMenu;
